import React from "react";
import classes from "./InputFile.module.css";

const InputFile = ({fileData, setFileData, text, name, showName}) => {

    const handleFileUpload = (e) => {
        if (e.target.files && e.target.files[0]) {
            setFileData({
                file: e.target.files[0],
                url: URL.createObjectURL(e.target.files[0]),
                name: e.target.files[0].name
            })
        }
    }

    return <div className={classes.HeaderInput}>
            <input type={'file'} name={name} onChange={handleFileUpload} accept={"image"} className={classes.InputFile}></input>
            {showName && <div className={classes.FileName}>{fileData.name}</div>}
            <span className={classes.BeforeInputFile}>{text}</span>
        </div>
    

}
export default InputFile;